import './KycFormExtended.less';

import React, { useEffect } from 'react';
import MinHeightPage from '../../../registration/view/MinHeightPage';
import Submit from '../../../forms/Submit';
import useForm from './submit';
import i18n from '../../../../common/i18n';
import { dispatch, useReframe } from 'nike-re-framejs';
import { kycForm$, loadDefaultKycForm, loadKycForm } from './h&s';
import { RegistrationLoading } from '../../../registration/view/RegistrationLoading';
import KycForm from './KycForm';
import KycFormExpandedHeader from './KycFormExpandedHeader';
import { isMobileChannel } from '../../../../common/util';
import clsx from 'clsx';

const KycFormExtended = ({ type, version }: { type: string; version: string }) => {
    const { subscribe } = useReframe();
    const kyc2 = subscribe(kycForm$);
    const [form, onSubmit] = useForm(version, kyc2?.max_answer_num);

    useEffect(() => {
        if (version && version === 'default') {
            dispatch(() => loadDefaultKycForm(type, version));
        } else {
            dispatch(() => loadKycForm(true));
        }
    }, [type, version]);

    if (!kyc2) {
        return <RegistrationLoading />;
    }

    return (
        <form
            onSubmit={onSubmit}
            autoComplete="off"
            className={clsx({
                'onb-padding': !isMobileChannel()
            })}
        >
            <MinHeightPage className="nui-kyc-form-extended">
                <div className="text-center mt-50 mb-20">
                    <KycFormExpandedHeader />
                </div>
                <KycForm form={form} questionList={kyc2.question} />
                <div className="c-black-100 fs-14 pb-20 mt-15 text-center">{kyc2.agreement_text}</div>
            </MinHeightPage>

            <div className="px-10 pt-10">
                <Submit
                    className="nui-button-max-300 nui-button-center"
                    form={form}
                    label={i18n('nui.button.send')}
                    dataAtid="kyc-extended-submit"
                />
            </div>
        </form>
    );
};

export default KycFormExtended;
